(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('SelectControlController', Controller);

    Controller.$inject = ['$scope', 'searchService'];

    function Controller($scope, searchService) {
        $scope.ctxSelectControl = {};

        $scope.searchControls = function () {
            var searchTerm = $scope.ctxSelectControl.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableControls = [];
                return;
            }
            searchService
                .searchControls(searchTerm, false)
                .then(function (foundControls) {
                    var foundControlsResults = foundControls.Results;
                    if ($scope.hideClosed) {
                        foundControlsResults = _.reject(foundControls.Results, { IsClosed: true });
                    }
                    
                    $scope.availableControls = foundControlsResults;
                });
        }
    }
})();